export const metadata = {
  title: "Eliminar cuenta — Mi Barrio App",
  description: "Cómo eliminar tu cuenta en Mi Barrio App y qué información se conserva.",
};

export default function EliminarCuenta() {
  return (
    <main className="min-h-screen bg-[#FAFAF9] text-[#1C1C1A]">
      <div className="mx-auto max-w-2xl px-6 py-16 sm:py-24">
        <p className="text-sm font-medium tracking-wide text-[#2F6B4F] uppercase">
          Mi Barrio App
        </p>
        <h1 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight">
          Eliminar tu cuenta
        </h1>
        <p className="mt-4 text-base leading-relaxed text-[#54534E]">
          Puedes eliminar tu cuenta de Mi Barrio App directamente desde la
          aplicación en cualquier momento, sin necesidad de contactar a
          soporte.
        </p>

        <section className="mt-12">
          <h2 className="text-lg font-semibold">Cómo eliminar tu cuenta</h2>
          <ol className="mt-4 space-y-4">
            <Step n={1}>
              Abre Mi Barrio App e ingresa a la sección{" "}
              <strong>Cuenta</strong>.
            </Step>
            <Step n={2}>
              En la parte inferior de la pantalla, toca{" "}
              <strong>Eliminar cuenta</strong>.
            </Step>
            <Step n={3}>
              Escribe <code className="rounded bg-[#EFEFEA] px-1.5 py-0.5 text-sm">
                ELIMINAR MI CUENTA
              </code>{" "}
              en el campo de texto para confirmar.
            </Step>
            <Step n={4}>
              Toca <strong>Aceptar</strong>. Tu cuenta se elimina de inmediato.
            </Step>
          </ol>
        </section>

        <section className="mt-12 border-t border-[#E4E3DD] pt-8">
          <h2 className="text-lg font-semibold">Qué información se elimina</h2>
          <p className="mt-3 text-base leading-relaxed text-[#54534E]">
            Se eliminan de forma permanente tus datos personales y
            sensibles: perfil, datos de contacto, documentos de
            verificación y credenciales de acceso.
          </p>
        </section>

        <section className="mt-8">
          <h2 className="text-lg font-semibold">Qué información se conserva</h2>
          <p className="mt-3 text-base leading-relaxed text-[#54534E]">
            Por motivos legales, contables y de auditoría, conservamos
            cierta información asociada a la actividad ya realizada en la
            plataforma, incluso después de eliminar la cuenta:
          </p>
          <ul className="mt-3 space-y-1.5 text-base leading-relaxed text-[#54534E]">
            <li>· Historial de órdenes y transacciones</li>
            <li>· Calificaciones realizadas o recibidas</li>
            <li>· Registros necesarios para auditoría y cumplimiento normativo</li>
          </ul>
          <p className="mt-3 text-base leading-relaxed text-[#54534E]">
            Esta información se conserva de forma disociada de tus datos
            personales eliminados y no se utiliza para identificarte.
          </p>
        </section>

        <p className="mt-12 text-sm text-[#8A8980]">
          ¿Tienes dudas sobre este proceso? Escríbenos a{" "}
          <a
            href="mailto:mibarrioapp151@gmail.com"
            className="underline underline-offset-2 hover:text-[#1C1C1A]"
          >
            mibarrioapp151@gmail.com
          </a>
          .
        </p>
      </div>
    </main>
  );
}

function Step({ n, children }) {
  return (
    <li className="flex gap-4">
      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#2F6B4F] text-xs font-medium text-white">
        {n}
      </span>
      <span className="text-base leading-relaxed text-[#54534E]">
        {children}
      </span>
    </li>
  );
}